import { getIdToken } from 'firebase/auth';
import { auth } from './firebase.config';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
// const BASE_URL = 'http://127.0.0.1:5001/coursecut-test/asia-south1/api';

export const makePost = async (url, data, headers = {}) => {
  const token = auth.currentUser ? await getIdToken(auth.currentUser) : '';
  return fetch(`${BASE_URL}${url}`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`,
      ...headers
    }
  });
};

export const makeGet = async (url, headers = {}) => {
  const token = auth.currentUser ? await getIdToken(auth.currentUser) : '';
  return fetch(`${BASE_URL}${url}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`,
      ...headers
    }
  });
};

export const updateScript = (projectId, data) => {
  const url = `/projects/${projectId}/update-script`;
  return makePost(url, data);
};

export const subscribeToPlan = (data) => {
  const url = `/user/plan/subscribe`;
  return makePost(url, data);
};

export const getPlanEstimate = (data) => {
  const url = `/user/plan/estimate`;
  return makePost(url, data);
};

export const cancelPlanSubscription = (data) => {
  const url = `/user/plan/cancel`;
  return makePost(url, data);
};

export const updatePlan = (data) => {
  const url = `/user/plan/update`;
  return makePost(url, data);
};

export const regenerateTimeline = (projectId, data = {}) => {
  const url = `/projects/${projectId}/regenerate-timeline`;
  return makePost(url, data);
};

export const exportXml = (projectId) => {
  const url = `/projects/${projectId}/export-xml`;
  return makeGet(url);
};

export const generateBrollPrompt = (projectId, data = {}) => {
  const url = `/projects/${projectId}/broll-prompt`;
  return makePost(url, data);
};

export const uploadIngredientImage = (data = {}) => {
  const url = '/user/media/ingredient';
  return makePost(url, data);
};

export const updateMusicPrompt = (projectId, data = {}) => {
  const url = `/projects/${projectId}/update-music`;
  return makePost(url, data);
};

export const restoreMusic = (projectId, data = {}) => {
  const url = `/projects/${projectId}/restore-music`;
  return makePost(url, data);
};

export const updateProjectAvatar = (projectId, avatarId) => {
  const url = `/projects/${projectId}/change-avatar`;
  return makePost(url, { avatarId });
};

export const createAd = (projectId, data = {}) => {
  const url = `/projects/${projectId}/create-ads`;
  return makePost(url, data);
};

export const updateAd = (projectId, data = {}) => {
  const url = `/projects/${projectId}/update-ads`;
  return makePost(url, data);
};

export const searchStockMedia = (query, page = 1) => {
  const params = new URLSearchParams({ q: query, page: String(page) });
  return makeGet(`/user/media/stock/search?${params.toString()}`);
};
